import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import LaserIcon from '../components/shared/LaserIcon.vue';
import ZoomIcon from '../components/shared/ZoomIcon.vue';
import MeetIcon from '../components/shared/MeetIcon.vue';
import TeamsIcon from '../components/shared/TeamsIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#FF9800',
        secondary: '#119bad',
        error: 'e15147',
        black: '#000',
        white: '#fff',
      },
    },
    options: {
      customProperties: true,
      variations: true,
    },
  },
  icons: {
    values: {
      'infinity-laserPointer': {
        component: LaserIcon,
      },
      'infinity-zoom': {
        component: ZoomIcon,
      },
      'infinity-meet': {
        component: MeetIcon,
      },
      'infinity-teams': {
        component: TeamsIcon,
      },
    },
  },
});
